import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { Card, CardBody, NavItem, NavLink } from "reactstrap";
import { useEffect, useState } from "react";
import { steps } from "../../initiator";

const CreateProductSteps = ({
    t, 
    activeTab,
    disabledTabs = []
}) => {
    const [ tabs, setTabs ] = useState(steps.map((iTab) => {
        return {
            tabKey: iTab.stepUniqueKey,
            title: iTab.title,
            active: iTab.stepUniqueKey === activeTab,
            completed: false
        }
    }))

    useEffect(() => {
        setTabs((currentState) => {
            const currentTabIndex = tabs.findIndex((cTab) => cTab.tabKey === activeTab)

            return [...currentState].map((cTab, index) => {
                return {...cTab, active: activeTab === cTab.tabKey, completed: index < currentTabIndex}
            })
        })
    }, [ activeTab ])

    return (
        <Card>
            <CardBody>
                <div className="bg-transparent wizard-steps-container shadow-none product-creating-wizard">
                    <div className="twitter-bs-wizard">
                        <ul className="twitter-bs-wizard-nav nav-justified nav nav-pills">
                            {tabs.map((tab, index) => {
                                return (
                                    <NavItem key={index} className={`${tab.completed ? 'completed' : ''}`}>
                                        <NavLink 
                                            active={tab.tabKey === activeTab}
                                            disabled={disabledTabs.includes(tab.tabKey) ? true : false} 
                                            className={
                                                `${tab.completed ? 'active': ''} ${tab.tabKey === activeTab ? ' current' : ''}`
                                            }>
                                            <span className="step-number">
                                                {tab.completed ? (
                                                    <i className="fa fa-check"></i>
                                                ) : (
                                                    index + 1
                                                )}
                                            </span>

                                            <span className="step-title">{t(tab.title)}</span>
                                        </NavLink>
                                    </NavItem>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </CardBody>
        </Card>
    )
}

export default withNamespaces()(
    withRouter(CreateProductSteps)
);